import {
  makeStyles,
  tokens,
  Field,
  Textarea,
  Text,
} from '@fluentui/react-components';
import { NoteRegular } from '@fluentui/react-icons';
import { OnboardingFormData } from '../../../hooks/useOnboardingForm';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  intro: {
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalM,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3,
  },
  characterCount: {
    textAlign: 'right',
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalXS,
  },
});

interface AdditionalStepProps {
  formData: OnboardingFormData;
  updateFormData: <K extends keyof OnboardingFormData>(field: K, value: OnboardingFormData[K]) => void;
}

const MAX_LENGTH = 2000;

export function AdditionalStep({ formData, updateFormData }: AdditionalStepProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <NoteRegular style={{ fontSize: '24px' }} />
        <Text>Additional Information</Text>
      </div>

      <Text className={styles.intro}>
        Use this space to provide any additional information, special requests, or notes
        that may be helpful for the onboarding process. This could include:
      </Text>

      <ul style={{ color: tokens.colorNeutralForeground3, marginLeft: tokens.spacingHorizontalL }}>
        <li>Special access requirements</li>
        <li>Equipment preferences</li>
        <li>Location-specific needs</li>
        <li>Training requirements</li>
        <li>Any other relevant information</li>
      </ul>

      <Field label="Additional Requests & Notes">
        <Textarea
          value={formData.additionalRequests}
          onChange={(_, data) => updateFormData('additionalRequests', data.value)}
          placeholder="Enter any additional information here..."
          rows={8}
          maxLength={MAX_LENGTH}
          resize="vertical"
          style={{ minHeight: '200px' }}
        />
      </Field>

      <Text className={styles.characterCount}>
        {formData.additionalRequests.length} / {MAX_LENGTH} characters
      </Text>
    </div>
  );
}
